export const Utf8 = 'utf8'

export const Binary = 'binary'
